import React from 'react';

import { Box, Skeleton, View } from '@rbilabs/universal-components';

export const MenuObjectSkeleton = () => (
  <View>
    <Box mb="$4">
      <Skeleton h="$72" w="full" mb="$3" rounded="4" mx="auto" />
    </Box>
    <Box p="$4">
      <Skeleton h="$6" rounded="full" mb="$8" />
      <Skeleton h="$4" rounded="full" mb="$8" width="40%" mx="auto" />
      <Skeleton h="$4" rounded="full" mb="$8" width="30%" />
      <Skeleton.Text lines={2} mb="$8" />
      <Skeleton.Text lines={2} mb="$8" />
      <Skeleton.Text lines={8} mb="$8" />
    </Box>
  </View>
);
